// extracted by mini-css-extract-plugin
module.exports = {"breakpoints":"'~styles/breakpoints.module.css'","TABLET_WIDTH":"768px","checkboxGroupLegend":"styles_checkboxGroupLegend__o0TDQ","helperText":"styles_helperText__T8WdR"};